/*       */

import { gql } from '@apollo/client';
import entitiesListShortCommonQuery from 'graphql/entities/common/entitiesListShortCommonQuery';
import entitiesListRisedCommonQuery from 'graphql/entities/common/entitiesListRisedCommonQuery';
import entitiesListBasicCommonQuery from 'graphql/entities/common/entitiesListBasicCommonQuery';
import entitiiesListFullCommonQuery from 'graphql/entities/common/entitiiesListFullCommonQuery';

export const entitiesListShortQuery = gql`
    query entitiesListShortQuery($startIndex: Int, $stopIndex: Int, $type: String!, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: $type, filterBy: $filterBy, excludeBy: $excludeBy)
        records: entities(type: $type, startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${entitiesListShortCommonQuery}
        }
    }
`;

export const entitiesListRaisedQuery = gql`
    query entitiesListRaisedQuery($startIndex: Int, $stopIndex: Int, $type: String!, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: $type, filterBy: $filterBy, excludeBy: $excludeBy)
        records: entities(type: $type, startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${entitiesListRisedCommonQuery}
        }
    }
`;
export const entitiesListRaisedTypeaheadQuery = gql`
    query entitiesListRaisedQuery($startIndex: Int, $stopIndex: Int, $type: String!, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        result: entities(type: $type, startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${entitiesListRisedCommonQuery}
        }
    }
`;
export const entitiesListBasicQuery = gql`
    query entitiesListShortQuery($startIndex: Int, $stopIndex: Int, $type: String!, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: $type, filterBy: $filterBy, excludeBy: $excludeBy)
        records: entities(type: $type, startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${entitiesListBasicCommonQuery}
        }
    }
`;

export const entitiesListFullQuery = gql`
    query entitiesListRaisedQuery($startIndex: Int, $stopIndex: Int, $type: String!, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: $type, filterBy: $filterBy, excludeBy: $excludeBy)
        records: entities(type: $type, startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${entitiiesListFullCommonQuery}

        }
    }
`;